import { render } from "./FileDescribe.vue?vue&type=template&id=72af7c56&scoped=true"
import script from "./FileDescribe.vue?vue&type=script&lang=js"
export * from "./FileDescribe.vue?vue&type=script&lang=js"

import "./FileDescribe.vue?vue&type=style&index=0&id=72af7c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72af7c56"]])

export default __exports__